import React from "react";
import { useNavigate } from "react-router-dom";

function NotFound() {
  const navigate = useNavigate();

  return (
    <div className="flex min-h-screen items-center justify-center bg-[var(--color-background)]">
      <div className="w-full max-w-md rounded-3xl border border-[var(--color-border)] bg-[var(--color-surface)] p-8 shadow-xl shadow-[var(--color-primary-soft)] text-center">
        <div className="mb-6">
          <h1 className="text-6xl font-bold text-[var(--color-primary)] mb-2">404</h1>
          <h2 className="text-2xl font-bold text-[var(--color-text-strong)]">
            Page Not Found
          </h2>
        </div>

        <p className="mb-6 text-[var(--color-text-muted)]">
          Sorry, the page you're looking for doesn't exist. It might have been moved or deleted.
        </p>

        <button
          onClick={() => navigate("/")}
          className="w-full rounded-lg bg-[var(--color-primary)] py-2 text-sm font-semibold text-[var(--color-on-primary)] shadow-sm transition hover:bg-[var(--color-primary-hover)] focus:outline-none focus:ring-2 focus:ring-[var(--color-primary-soft)]"
        >
          Go Home
        </button>
      </div>
    </div>
  );
}

export default NotFound;
